import { useQuery } from '@tanstack/react-query'
import { lcCoachingApi } from '@/api/lcCoaching'
import { coachingKeys } from './useCoachingToday'

export function useLearnerToday(learnerId: number, date?: string, enabled = true) {
  return useQuery({
    queryKey: coachingKeys.learnerToday(learnerId, date),
    queryFn: () => lcCoachingApi.getLearnerToday(learnerId, date),
    enabled: enabled && Number.isFinite(learnerId) && learnerId > 0,
    staleTime: 30_000,
  })
}
